<div class="flex items-center h-full">
  <div class="w-40 pr-8 flex-shrink-0">
    <a routerLink="/">
      <img src="assets/images/logo-white.svg" alt="Emsys">
    </a>
  </div>

  <vm-teleport name="header"/>
  <dashboard-header-nav class="pl-8 ml-auto"/>
</div>
